import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import Translate from 'react-translate-component';
import Close from '../../components/svg/close';

export class ModalContainer extends React.Component {

  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    classes: PropTypes.string,
    wide: PropTypes.bool,
    callback: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    headerSlot: PropTypes.any,
    children: PropTypes.any,
    titleMargin: PropTypes.bool,
    hideClose: PropTypes.bool,
    shrink: PropTypes.bool
  };

  constructor (props) {
    super(props);

    this.reject = this.reject.bind(this);
    this.renderHeaderSlot = this.renderHeaderSlot.bind(this);
  }

  reject () {
    this.props.callback(false);
  }

  renderHeaderSlot () {
    if (this.props.headerSlot) {
      return this.props.headerSlot;
    }

    return null;
  }

  renderCloseButton () {
    if (!this.props.hideClose) {
      return <Close
        color='#000000'
        classes='new-modal-close'
        callback={this.reject}
      />;
    }
  }

  render () {
    const defaultClass = this.props.shrink ? 'new-modal pre-wrap' : 'new-modal cover-mobile pre-wrap';
    const wideClass = this.props.wide ? ' new-modal-wide' : '';
    const customClasses = ` ${this.props.classes}`;

    const titleClass = 'new-modal-header-title-container';
    const titleMargin = this.props.titleMargin ? ' title-margin' : '';

    return (<Modal
      className={`${defaultClass}${wideClass}${customClasses}`}
      contentLabel=''
      isOpen={this.props.isOpen}
    >
      <div className='new-modal-header'>
        <div className={`${titleClass}${titleMargin}`}>
          <Translate className='modal-title' content={this.props.title} />
          {this.renderCloseButton()}
        </div>
        {this.renderHeaderSlot()}
      </div>
      <div className='new-modal-body'>
        {this.props.children}
      </div>
    </Modal>);
  }
}

export default ModalContainer;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/modal/modal-container.js
 **/